module.exports = __webpack_public_path__ + "img/hontai_ItalianRed.50a2250a.png";